import { render } from "./SalePriceColumn.vue?vue&type=template&id=5998e2dd&ts=true"
import script from "./SalePriceColumn.vue?vue&type=script&lang=ts"
export * from "./SalePriceColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__